module.exports = __webpack_public_path__ + "static/media/blueCalendar.c5eac7d4.svg";